import { render, staticRenderFns } from "./TeacherCourseDetail.vue?vue&type=template&id=7c697b7a&scoped=true&"
import script from "./TeacherCourseDetail.vue?vue&type=script&lang=js&"
export * from "./TeacherCourseDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCourseDetail.vue?vue&type=style&index=0&id=7c697b7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c697b7a",
  null
  
)

export default component.exports